import { Skeleton } from "~/components/ui/skeleton";

/** A single placeholder shaped like a DocItem row (icon box + content lines). */
export const DocItemSkeleton = () => (
  <div className="my-4 flex gap-4 border-b border-[var(--ui-03)] pb-4">
    <Skeleton className="h-20 w-[70px] shrink-0 rounded-sm" />
    <div className="flex min-w-0 flex-1 flex-col gap-2 pt-1">
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-3 w-2/5" />
      <Skeleton className="mt-1 h-3 w-3/4" />
      <Skeleton className="h-3 w-1/2" />
      <Skeleton className="mt-1 h-5 w-44" />
    </div>
  </div>
);

/** A list of DocItem-shaped placeholders for the documents list loading state. */
const DocListSkeleton = ({ count = 6 }: { count?: number }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <DocItemSkeleton key={i} />
    ))}
  </>
);

export default DocListSkeleton;
